// Hàm thuần cho hồ sơ đánh giá hợp tác (spec 2026-10-12 §4). Câu chữ và giới hạn khớp payment (BrandProfileConst).
import type { BrandOrdererProfile, BrandProfileMetrics } from '../api/payment/brand-profile.api';
import { avgStarsLabel } from './brand-rating';

export const BRAND_COLLAB_TAB = 'hop-tac';

/** Tab "Hợp tác" chỉ có khi hồ sơ hiện; ẩn thì rơi về dòng thời gian để không còn khung trống. */
export const resolveProfileTab = (tab: string, collabVisible: boolean): string =>
  tab === BRAND_COLLAB_TAB && !collabVisible ? 'timeline' : tab;

export const BRAND_PROFILE_COPY = {
  tabLabel: 'Hợp tác',
  notEnoughData: 'Chưa đủ dữ liệu',
  notEnoughDataHint: 'Số liệu hiện khi đã có ít nhất 3 đơn kết thúc.',
  noReviews: 'Chưa có đánh giá nào.',
  noRatings: 'Chưa có lượt đánh giá nào',
  empty: 'Chưa có',
  replyPlaceholder: 'Viết trả lời của bạn',
  replyButton: 'Gửi trả lời',
  replyOnceHint: 'Mỗi đánh giá chỉ trả lời được một lần và không sửa được sau khi gửi.',
  replySent: 'Đã gửi trả lời.',
  creatorReplyLabel: 'Creator trả lời',
  ordererReplyLabel: 'Người đặt trả lời',
  loadMore: 'Xem thêm',
} as const;

export const REPLY_MAX_LENGTH = 500;
export const HIDE_REASON_LIMITS = { minLength: 5, maxLength: 300 } as const;

export const validateReplyText = (text: string | null | undefined): string | null => {
  const t = (text ?? '').trim();
  return t.length < 1 || t.length > REPLY_MAX_LENGTH ? 'Trả lời từ 1 đến 500 ký tự.' : null;
};

export const validateHideReason = (reason: string | null | undefined): string | null => {
  const t = (reason ?? '').trim();
  return t.length < HIDE_REASON_LIMITS.minLength || t.length > HIDE_REASON_LIMITS.maxLength ? 'Lý do ẩn từ 5 đến 300 ký tự.' : null;
};

const monthYear = (iso: string): string | null => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return `${d.getMonth() + 1}/${d.getFullYear()}`;
};

export const reviewMonthLabel = (iso: string): string => {
  const my = monthYear(iso);
  return my ? `Tháng ${my}` : '';
};

export const joinedLabel = (iso: string | null | undefined): string | null => {
  if (!iso) return null;
  const my = monthYear(iso);
  return my ? `Tham gia sàn từ tháng ${my}` : null;
};

export interface MetricTile {
  key: string;
  label: string;
  value: string;
}

export const metricTiles = (m: BrandProfileMetrics, role: 'creator' | 'orderer'): MetricTile[] => [
  { key: 'avg', label: 'Điểm trung bình', value: m.average == null ? BRAND_PROFILE_COPY.empty : avgStarsLabel(m.average) },
  { key: 'done', label: 'Đơn đã hoàn tất', value: String(m.completedDeals) },
  {
    key: 'ontime',
    label: role === 'creator' ? 'Nộp bài đúng hạn' : 'Duyệt bài đúng hạn',
    value: m.onTimePercent == null ? BRAND_PROFILE_COPY.empty : `${m.onTimePercent}%`,
  },
  { key: 'disputes', label: 'Tranh chấp bị xử thua', value: String(m.disputesLost) },
];

export const ordererBadgeLabel = (p: Pick<BrandOrdererProfile, 'kind' | 'verified'>): string | null => {
  if (p.kind === 'Individual') return 'Cá nhân đã định danh';
  return p.verified ? 'Đã xác minh doanh nghiệp' : null;
};

export const ordererProfilePath = (adAccountId: string) => `/collab/orderer/${adAccountId}`;

/** Trang hồ sơ creator mở thẳng tab "Hợp tác"; không có handle thì không dựng link. */
export const creatorCollabPath = (userName: string | null | undefined): string | null =>
  userName && userName.trim() ? `/user/${encodeURIComponent(userName.trim())}?tab=${BRAND_COLLAB_TAB}` : null;
